const tagFor = [
  {
    name: 'Task Group',
    value: 'task-group',
  },
  {
    name: 'User',
    value: 'user',
  },
];

export default tagFor;
